import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { CNS_ASSET_DAY_BASE_PATH } from '../../../../../../../../../features/dtcc/cns/asset-day/cns-asset-day-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset-day/_asset-day')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'cns-asset-days-list',
        label: 'DTCC',
        to: CNS_ASSET_DAY_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
